// extracted by mini-css-extract-plugin
module.exports = {"BILL_RECEIVE":"BILL_RECEIVE-e6561ab692002696d1336d0dc36cd453"};